import React, {Component} from "react";

import WithUserData from "../WithUserData";
import AdsOffers from "../../../assets/images/ads_offers.svg";
import JobListings from "../../../assets/images/job_listings.svg";
import StudioBooking from "../../../assets/images/studio_bookings.svg";
import Events from "../../../assets/images/events.svg";
import MemberOffers from "../../../assets/images/member_offers.svg";

export default class Club extends Component {

    render() {
        const buttonClassName = "cursor-pointer w-full h-16 border border-black text-gray-900 text-lg rounded-lg flex items-center hover:bg-gray-200 mt-0 sm:mt-3"
        const iconClassName = "h-10";
        return (
            <WithUserData>
                {() => {
                    return (
                        <div className='w-full h-full flex flex-col justify-end sm:justify-start'>
                            <div className={`${buttonClassName} mt-6 sm:mt-20`}>
                                <div className="w-24 flex items-center justify-center">
                                    <img src={AdsOffers} className="h-12" alt="AdsOffers" />
                                </div>
                                <span>My ads</span>
                            </div>
                            <div className={`${buttonClassName}`}>
                                <div className="w-24 flex items-center justify-center">
                                    <img src={JobListings} className={iconClassName} alt="JobListings" />
                                </div>
                                <span>Job listings</span>
                            </div>
                            <div className={`${buttonClassName}`}>
                                <div className="w-24 flex items-center justify-center">
                                    <img src={StudioBooking} className={iconClassName} alt="StudioBooking" />
                                </div>
                                <span>Studio booking</span>
                            </div>
                            <div className={`${buttonClassName}`}>
                                <div className="w-24 flex items-center justify-center">
                                    <img src={Events} className={iconClassName} alt="Events" />
                                </div>
                                <span>Events</span>
                            </div>
                            <div className={`${buttonClassName}`}>
                                <div className="w-24 flex items-center justify-center">
                                    <img src={MemberOffers} className={iconClassName} alt="MemberOffers" />
                                </div>
                                <span>Member offers</span>
                            </div>
                        </div>
                    )
                }}
            </WithUserData>
        );
    }
}
